<template>
    <span
        :class="[
            isHome ? 'countdown-2' : 'countdown',
            isProductPage && $scope.EXPERIMENT_VAR6 ? 'experiment-countdown countdown-product' : '',
        ]"
    >
        <div class="promo-text-ab2-mobile" v-if="isHome && !$scope.EXPERIMENT_VAR6">
            {{ alt }}
        </div>
        <!-- Original countdown when EXPERIMENT_VAR6 is false -->
        <div class="countdown-container" v-if="!$scope.EXPERIMENT_VAR6 && isHome">
            <div
                class="countdown-text"
                style="color: white; align-content: flex-end"
                :style="
                    'color: ' +
                    ($scope.active_counter && $scope.active_counter.length > 0
                        ? $scope.active_counter[0].counter_color
                        : '') +
                    ' !important'
                "
            >
                Acaba em:
            </div>
            <div>
                <span
                    v-if="showDays && days"
                    class="days"
                    :style="
                        'color: ' +
                        ($scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_color
                            : '') +
                        ' !important'
                    "
                >
                    <span>{{ days }}</span>
                </span>
                <span
                    v-if="showDays && days"
                    class="days-letter"
                    :style="
                        'background-color: ' +
                        ($scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_background_color
                            : '') +
                        ' !important; color: ' +
                        ($scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_color
                            : '') +
                        ' !important'
                    "
                    >d</span
                >
                <span
                    class="hours"
                    :style="
                        'color: ' +
                        ($scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_color
                            : '') +
                        ' !important'
                    "
                >
                    <span>{{ hours.toString().split('')[0] }}</span>
                    <span>{{ hours.toString().split('')[1] }}</span>
                </span>
                <span
                    class="hours-letter"
                    :style="
                        'background-color: ' +
                        ($scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_background_color
                            : '') +
                        ' !important; color: ' +
                        ($scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_color
                            : '') +
                        ' !important'
                    "
                    >h</span
                >
                <span
                    class="minutes"
                    :style="
                        'color: ' +
                        ($scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_color
                            : '') +
                        ' !important'
                    "
                >
                    <span>{{ minutes.toString().split('')[0] }}</span>
                    <span>{{ minutes.toString().split('')[1] }}</span>
                </span>
                <span
                    class="hours-letter"
                    :style="
                        'background-color: ' +
                        ($scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_background_color
                            : '') +
                        ' !important; color: ' +
                        ($scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_color
                            : '') +
                        ' !important'
                    "
                    >m</span
                >
                <span
                    class="seconds"
                    :style="
                        'color: ' +
                        ($scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_color
                            : '') +
                        ' !important'
                    "
                >
                    <span>{{ seconds.toString().split('')[0] }}</span>
                    <span>{{ seconds.toString().split('')[1] }}</span>
                </span>
                <span
                    class="seconds-letter"
                    :style="
                        'background-color: ' +
                        ($scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_background_color
                            : '') +
                        ' !important; color: ' +
                        ($scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_color
                            : '') +
                        ' !important'
                    "
                    >s</span
                >
            </div>
        </div>

        <!-- New countdown when EXPERIMENT_VAR6 is true and isHome -->
        <div class="countdown-container" v-if="$scope.EXPERIMENT_VAR6 && isHome">
            <div
                :class="[
                    'countdown-wrapper d-flex flex-align-center flex-justify-center',
                    { 'countdown-banner-container': $scope.isMobile },
                ]"
            >
                <template v-if="$scope.isMobile">
                    <div class="d-flex flex-align-center">
                        {{ bannerText || 'Acaba em:' }}
                    </div>
                </template>
                <div
                    class="countdown-clock d-flex flex-align-center flex-justify-center pos-absolute pos-left"
                    v-if="!$scope.isMobile || showClock"
                >
                    <span
                        class="clock-container d-flex flex-align-center flex-justify-center"
                        :style="
                            'color: ' +
                            ($scope.PROMO && $scope.PROMO.contador_cor
                                ? $scope.PROMO.contador_cor
                                : $scope.active_counter && $scope.active_counter.length > 0
                                ? $scope.active_counter[0].counter_background_color
                                : '') +
                            ' !important'
                        "
                    ></span>
                </div>
                <div
                    class="timer-container d-flex flex-align-center"
                    :class="{ 'mobile-timer': $scope.isMobile }"
                >
                    <div
                        class="countdown-warning-text d-flex flex-align-center"
                        v-if="!$scope.isMobile"
                        :style="
                            'color: ' +
                            ($scope.active_counter && $scope.active_counter.length > 0
                                ? $scope.active_counter[0].counter_color
                                : '') +
                            ' !important'
                        "
                    >
                        Acaba em:
                    </div>
                    <div class="countdown-numbers d-flex flex-align-center">
                        <span
                            v-if="showDays && days"
                            class="timer-number d-flex flex-align-center"
                            :style="
                                'color: ' +
                                ($scope.active_counter && $scope.active_counter.length > 0
                                    ? $scope.active_counter[0].counter_color
                                    : '') +
                                ' !important'
                            "
                        >
                            {{ days }}
                        </span>
                        <span
                            v-if="showDays && days"
                            class="timer-letter mr-1"
                            :style="
                                'background-color: ' +
                                ($scope.PROMO && $scope.PROMO.contador_cor
                                    ? $scope.PROMO.contador_cor
                                    : 'transparent') +
                                ' !important; color: ' +
                                ($scope.PROMO && $scope.PROMO.contador_texto_cor
                                    ? $scope.PROMO.contador_texto_cor
                                    : 'black') +
                                ' !important'
                            "
                            >d</span
                        >
                        <span
                            class="timer-number d-flex flex-align-center mx-1"
                            :style="
                                'color: ' +
                                ($scope.active_counter && $scope.active_counter.length > 0
                                    ? $scope.active_counter[0].counter_color
                                    : '') +
                                ' !important'
                            "
                        >
                            <span class="digit mr-1">{{ hours.toString().charAt(0) }}</span>
                            <span class="digit mx-auto-xs">{{ hours.toString().charAt(1) }}</span>
                        </span>
                        <span
                            class="timer-letter mr-2"
                            :style="
                                'background-color: ' +
                                ($scope.active_counter && $scope.active_counter.length > 0
                                    ? $scope.active_counter[0].counter_background_color
                                    : '') +
                                ' !important; color: ' +
                                ($scope.active_counter && $scope.active_counter.length > 0
                                    ? $scope.active_counter[0].counter_color
                                    : '') +
                                ' !important'
                            "
                            >h</span
                        >
                        <span
                            class="timer-number d-flex flex-align-center mr-1"
                            :style="
                                'color: ' +
                                ($scope.active_counter && $scope.active_counter.length > 0
                                    ? $scope.active_counter[0].counter_color
                                    : '') +
                                ' !important'
                            "
                        >
                            <span class="digit mr-1">{{ minutes.toString().charAt(0) }}</span>
                            <span class="digit mx-auto-xs">{{ minutes.toString().charAt(1) }}</span>
                        </span>
                        <span
                            class="timer-letter mr-1"
                            :style="
                                'background-color: ' +
                                ($scope.active_counter && $scope.active_counter.length > 0
                                    ? $scope.active_counter[0].counter_background_color
                                    : '') +
                                ' !important; color: ' +
                                ($scope.active_counter && $scope.active_counter.length > 0
                                    ? $scope.active_counter[0].counter_color
                                    : '') +
                                ' !important'
                            "
                            >m</span
                        >
                        <span
                            class="timer-number d-flex flex-align-center mx-1"
                            :style="
                                'color: ' +
                                ($scope.active_counter && $scope.active_counter.length > 0
                                    ? $scope.active_counter[0].counter_color
                                    : '') +
                                ' !important'
                            "
                        >
                            <span class="digit mr-1">{{ seconds.toString().charAt(0) }}</span>
                            <span class="digit mx-auto-xs">{{ seconds.toString().charAt(1) }}</span>
                        </span>
                        <span
                            class="timer-letter"
                            :style="
                                'background-color: ' +
                                ($scope.active_counter && $scope.active_counter.length > 0
                                    ? $scope.active_counter[0].counter_background_color
                                    : '') +
                                ' !important; color: ' +
                                ($scope.active_counter && $scope.active_counter.length > 0
                                    ? $scope.active_counter[0].counter_color
                                    : '') +
                                ' !important'
                            "
                            >s</span
                        >
                    </div>
                </div>
                <a
                    class="countdown-chevron d-flex flex-align-center flex-justify-center pos-absolute pos-right"
                >
                    <span
                        class="chevron-container d-flex flex-align-center flex-justify-center"
                        :style="
                            'color: ' +
                            ($scope.active_counter && $scope.active_counter.length > 0
                                ? $scope.active_counter[0].counter_color
                                : '') +
                            ' !important'
                        "
                    ></span>
                </a>
            </div>
        </div>

        <!-- Original version for non-home when EXPERIMENT_VAR6 is false -->
        <div v-if="!$scope.EXPERIMENT_VAR6 && !isHome">
            <span v-if="showDays && days" class="days"
                >{{ days
                }}<span class="days-letter" :style="{ color: timeUnitColor }">d</span></span
            >
            <span class="hours">
                <span :class="countdownClass">{{ hours.toString().split('')[0] }}</span>
                <span :class="countdownClass">{{ hours.toString().split('')[1] }}</span>
            </span>
            <span class="hours-letter" :style="{ color: timeUnitColor }">h</span>
            <span class="minutes">
                <span :class="countdownClass">{{ minutes.toString().split('')[0] }}</span>
                <span :class="countdownClass">{{ minutes.toString().split('')[1] }}</span>
            </span>
            <span :style="{ color: timeUnitColor }" class="hours-letter">m</span>
            <span class="seconds">
                <span :class="countdownClass">{{ seconds.toString().split('')[0] }}</span>
                <span :class="countdownClass">{{ seconds.toString().split('')[1] }}</span>
            </span>
            <span :style="{ color: timeUnitColor }" class="hours-letter">s</span>
        </div>

        <!-- New version for non-home when EXPERIMENT_VAR6 is true -->
        <div
            v-if="$scope.EXPERIMENT_VAR6 && !isHome"
            class="countdown-wrapper d-flex flex-align-center flex-justify-center"
            :class="{
                'countdown-banner-container': $scope.isMobile,
                'product-countdown-wrapper': isProductPage,
            }"
        >
            <template v-if="$scope.isMobile">
                <div class="d-flex flex-align-center">
                    {{ bannerText || (showLabel ? 'Acaba em:' : '') }}
                </div>
            </template>
            <div
                class="countdown-clock d-flex flex-align-center flex-justify-center pos-absolute pos-left"
                v-if="(!$scope.isMobile || showClock) && showClock && !isProductPage"
            >
                <span
                    class="clock-container d-flex flex-align-center flex-justify-center"
                    :style="
                        'color: ' +
                        ($scope.PROMO && $scope.PROMO.contador_cor
                            ? $scope.PROMO.contador_cor
                            : $scope.active_counter && $scope.active_counter.length > 0
                            ? $scope.active_counter[0].counter_background_color
                            : '') +
                        ' !important'
                    "
                ></span>
            </div>
            <div
                class="timer-container d-flex flex-align-center flex-justify-center"
                :class="{
                    'mobile-timer': $scope.isMobile,
                    'w-full': isProductPage,
                }"
            >
                <div
                    class="countdown-warning-text d-flex flex-align-center"
                    v-if="showLabel && !$scope.isMobile && !isProductPage"
                >
                    Acaba em:
                </div>
                <div class="countdown-numbers d-flex flex-align-center">
                    <span
                        v-if="showDays && days"
                        :class="[
                            'days d-flex flex-align-center',
                            isProductPage ? 'product-timer text-bold mx-0' : '',
                        ]"
                    >
                        {{ days
                        }}<span
                            :class="[
                                'days-letter d-flex flex-align-center',
                                isProductPage ? 'product-timer-letter mr-1 text-regular' : '',
                            ]"
                            >d</span
                        >
                    </span>
                    <span
                        :class="[
                            'timer-number d-flex flex-align-center mx-1',
                            isProductPage ? 'product-timer text-bold mx-0' : '',
                        ]"
                    >
                        <span class="digit mr-1">{{ hours.toString().charAt(0) }}</span>
                        <span class="digit mx-auto-xs">{{ hours.toString().charAt(1) }}</span>
                    </span>
                    <span
                        :class="[
                            'timer-letter d-flex flex-align-center mr-2',
                            isProductPage ? 'product-timer-letter mr-2 text-regular' : '',
                        ]"
                        >h</span
                    >
                    <span
                        :class="[
                            'timer-number d-flex flex-align-center mr-1',
                            isProductPage ? 'product-timer text-bold mx-0' : '',
                        ]"
                    >
                        <span class="digit mr-1">{{ minutes.toString().charAt(0) }}</span>
                        <span class="digit mx-auto-xs">{{ minutes.toString().charAt(1) }}</span>
                    </span>
                    <span
                        :class="[
                            'timer-letter d-flex flex-align-center mr-1',
                            isProductPage ? 'product-timer-letter mr-1 text-regular' : '',
                        ]"
                        >m</span
                    >
                    <span
                        :class="[
                            'timer-number d-flex flex-align-center mx-1',
                            isProductPage ? 'product-timer text-bold mx-0' : '',
                        ]"
                    >
                        <span class="digit mr-1">{{ seconds.toString().charAt(0) }}</span>
                        <span class="digit mx-auto-xs">{{ seconds.toString().charAt(1) }}</span>
                    </span>
                    <span
                        :class="[
                            'timer-letter d-flex flex-align-center',
                            isProductPage ? 'product-timer-letter text-regular' : '',
                        ]"
                        >s</span
                    >
                </div>
            </div>
            <a
                :href="link"
                class="countdown-chevron d-flex flex-align-center flex-justify-center pos-absolute pos-right"
                v-if="!isProductPage"
            >
                <span
                    class="chevron-container d-flex flex-align-center flex-justify-center"
                    :style="{
                        color:
                            $scope.PROMO && $scope.PROMO.contador_texto_cor
                                ? $scope.PROMO.contador_texto_cor
                                : 'black',
                    }"
                ></span>
            </a>
        </div>

        <div class="promo-button-ab2-mobile" v-if="isHome && !$scope.EXPERIMENT_VAR6">Confira</div>
    </span>
</template>

<script>
    export default {
        name: 'Countdown',

        props: {
            deadline: Date,
            showDays: Boolean,
            alt: String,
            isHome: Boolean,
            isProductPage: {
                type: Boolean,
                default: false,
            },
            showLabel: {
                type: Boolean,
                default: false,
            },
            link: {
                type: String,
                default: '',
            },
            bannerText: {
                type: String,
                default: '',
            },
            showClock: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                realDeadline: null, // usado quando a data final do contador é diferente da data final da oferta
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            };
        },

        watch: {
            deadline: {
                immediate: true,
                handler(date) {
                    if (date) {
                        this.realDeadline = date.getTime();
                    }
                },
            },
        },

        computed: {
            countdownClass() {
                return this.$scope.EXPERIMENT_VAR6 ? 'countdown-number' : '';
            },

            timeUnitColor() {
                return this.$scope.EXPERIMENT_VAR6 && this.$scope.PROMO.contador_texto_cor
                    ? this.$scope.PROMO.contador_texto_cor
                    : '';
            },
        },

        mounted() {
            this.update();
            setInterval(this.update.bind(this), 1000);
        },

        methods: {
            getValues() {
                const now = new Date();
                const diff = this.realDeadline ? this.realDeadline - now.getTime() : 0;

                if (diff < 0) {
                    return {
                        hours: 0,
                        minutes: 0,
                        seconds: 0,
                    };
                }

                const hours = Math.floor(diff / (60 * 60 * 1000));

                return {
                    days: Math.floor(diff / (60 * 60 * 1000 * 24)),
                    hours: this.showDays ? hours % 24 : hours,
                    minutes: Math.floor(diff / (60 * 1000)) % 60,
                    seconds: Math.floor(diff / 1000) % 60,
                };
            },
            update() {
                const values = this.getValues();
                this.days = values.days;
                this.hours = values.hours < 10 ? `0${values.hours}` : values.hours;
                this.minutes = values.minutes < 10 ? `0${values.minutes}` : values.minutes;
                this.seconds = values.seconds < 10 ? `0${values.seconds}` : values.seconds;
            },
        },
    };
</script>
